import { GetRecentConversationsUseCase } from './GetRecentConversationsUseCase'
import { recentConversationsRepository } from '../../../data-access/repositories'

export const getRecentConversations = new GetRecentConversationsUseCase({
  recentConversationsRepository,
}).execute
